// src/xmlFormatterUtils.js
export const formatXml = (xml, tabSize = 2) => {
    try {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xml, "application/xml");

        const parseError = xmlDoc.getElementsByTagName("parsererror");
        if (parseError.length > 0) {
            return "Invalid XML";
        }

        const tab = ' '.repeat(tabSize);

        // Recursive serializer — tracks indent depth, avoids XMLSerializer (which adds xmlns)
        const serializeNode = (node, indent) => {
            if (node.nodeType === 3) { // text node
                const text = node.nodeValue.trim();
                return text ? text : null;
            }
            if (node.nodeType !== 1) return null; // skip comments, PI nodes, etc.

            const tagName = node.tagName;

            // Build attribute string (only actual attributes, no xmlns injection)
            let attrs = '';
            for (let i = 0; i < node.attributes.length; i++) {
                const attr = node.attributes[i];
                attrs += ` ${attr.name}="${attr.value}"`;
            }

            const childResults = Array.from(node.childNodes)
                .map(c => serializeNode(c, indent + tab))
                .filter(s => s !== null);

            if (childResults.length === 0) {
                return `${indent}<${tagName}${attrs}/>`;
            }

            // Single inline text child — keep on one line.
            // Use trimStart() before startsWith('<') because element results carry
            // their leading indent, so a plain startsWith('<') would wrongly treat
            // them as text and inline them.
            if (childResults.length === 1 && !childResults[0].trimStart().startsWith('<')) {
                return `${indent}<${tagName}${attrs}>${childResults[0]}</${tagName}>`;
            }

            // Block children — each on its own indented line.
            // Again use trimStart() to correctly identify already-indented element results.
            const inner = childResults.map(c =>
                c.trimStart().startsWith('<') ? c : `${indent}${tab}${c}`
            ).join('\n');
            return `${indent}<${tagName}${attrs}>\n${inner}\n${indent}</${tagName}>`;
        };

        return serializeNode(xmlDoc.documentElement, '');
    } catch (error) {
        return "Invalid XML";
    }
};
  